import React, { useState, useEffect, useRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { loadUser, logoutUser } from '@store/reducers/auth';
import { toggleSidebarMenu } from '@app/store/reducers/ui';
import * as AuthService from '../../services/auth';
import Dashboard from '@pages/Dashboard';
import Blank from '@pages/Blank';
import Profile from '@pages/profile/Profile';
import PhanquyenList from '@app/pages/FPhanquyen/PhanquyenList';
import { PhanquyenEdit } from '@app/pages/FPhanquyen/PhanquyenEdit';
import Nhanviens from '@pages/nhanvien/Nhanviens';
import { NhanvienEdit } from '@pages/nhanvien/NhanvienEdit';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';
import PageLoading from '../../components/page-loading/PageLoading';

import { CapcoquanEdit } from "@pages/FMasterData/FCapcoquan/CapcoquanEdit";
import CapcoquanList from "@pages/FMasterData/FCapcoquan/CapcoquanList";

import {Uploads} from "@pages/upload/Uploads";

import {alertService} from "@app/services/alertService";

import * as mainService from '@app/services/mainService';
import Loaiphansucap1List from '@app/pages/FMasterData/FLoaiphansucap1/Loaiphansucap1List';
import { Loaiphansucap1Edit } from '@app/pages/FMasterData/FLoaiphansucap1/Loaiphansucap1Edit';
import Loaiphansucap2List from '@app/pages/FMasterData/FLoaiphansucap2/Loaiphansucap2List';
import { Loaiphansucap2Edit } from '@app/pages/FMasterData/FLoaiphansucap2/Loaiphansucap2Edit';
import NhomphansuList from '@app/pages/FMasterData/FNhomphansu/NhomphansuList';
import { NhomphansuEdit } from '@app/pages/FMasterData/FNhomphansu/NhomphansuEdit';
import PhansuList from '@app/pages/FMasterData/FPhansu/PhansuList';
import { PhansuEdit } from '@app/pages/FMasterData/FPhansu/PhansuEdit';
import NhadanList from '@app/pages/FMasterData/FNhadan/NhadanList';
import { NhadanEdit } from '@app/pages/FMasterData/FNhadan/NhadanEdit';
import UserList from '@app/pages/FMasterData/FUser/UserList';
import { UserEdit } from '@app/pages/FMasterData/FUser/UserEdit';
import {DaohuuEdit} from '@app/pages/FMasterData/FDaohuu/DaohuuEdit';
import DaohuuList from '@app/pages/FMasterData/FDaohuu/DaohuuList';
import NhomsukienList from '@app/pages/FMasterData/FNhomsukien/NhomsukienList';
import { NhomsukienEdit } from '@app/pages/FMasterData/FNhomsukien/NhomsukienEdit';
import PhanloaisukienList from '@app/pages/FMasterData/FPhanloaisukien/PhanloaisukienList';
import { PhanloaisukienEdit } from '@app/pages/FMasterData/FPhanloaisukien/PhanloaisukienEdit';
import CoquanList from "@pages/FMasterData/FCoquan/CoquanList";
import {CoquanEdit} from "@pages/FMasterData/FCoquan/CoquanEdit";
import LoaibieumautailieuList from "@pages/FMasterData/FLoaibieumautailieu/LoaibieumautailieuList";
import {LoaibieumautailieuEdit} from "@pages/FMasterData/FLoaibieumautailieu/LoaibieumautailieuEdit";
import BieumautailieuList from "@pages/FMasterData/FBieumautailieu/BieumautailieuList";
import {BieumautailieuEdit} from "@pages/FMasterData/FBieumautailieu/BieumautailieuEdit";
import HinhthucList from "@pages/FMasterData/FHinhthuc/HinhthucList";
import {HinhthucEdit} from "@pages/FMasterData/FHinhthuc/HinhthucEdit";
import LoaithongbaoList from "@pages/FMasterData/FLoaithongbao/LoaithongbaoList";
import {LoaithongbaoEdit} from "@pages/FMasterData/FLoaithongbao/LoaithongbaoEdit";
import {ThongbaoEdit} from "@pages/FMasterData/FThongbao/ThongbaoEdit";
import ThongbaoList from "@pages/FMasterData/FThongbao/ThongbaoList";
import ThanhgiaoList from "@pages/FMasterData/FThanhgiao/ThanhgiaoList";
import {ThanhgiaoEdit} from "@pages/FMasterData/FThanhgiao/ThanhgiaoEdit";
import PhanquyenappList from "@pages/FSystem/FPhanquyenapp/PhanquyenappList";
import {PhanquyenappEdit} from "@pages/FSystem/FPhanquyenapp/PhanquyenappEdit";
import SukienList from "@pages/FSukien/FSukien/SukienList";
import {SukienEdit} from "@pages/FSukien/FSukien/SukienEdit";
import tokenManager from "@app/services/tokenManager";
import SukienDaohuuList from "@pages/FSukien/FSukien/SukienDaohuuList";
import SukienNhadanList from "@pages/FSukien/FSukien/SukienNhadanList";

const Main = () => {
	const dispatch = useDispatch();
	const isSidebarMenuCollapsed = useSelector((state) => state.ui.isSidebarMenuCollapsed);
	const screenSize = useSelector((state) => state.ui.screenSize);
	const [appLoadingState, updateAppLoading] = useState(true); // Start with loading = true

	// Use refs to track initialization and prevent re-renders
	const isInitializedRef = useRef(false);
	const intervalRef = useRef(null);
	const isFirstRender = useRef(true);

	const handleToggleMenuSidebar = () => {
		dispatch(toggleSidebarMenu());
	};

	const loadStore = async () => {
		//console.log('Main: Loading store data (NOT menu data)...');
		//console.log('🔍 Token BEFORE getAllTrangthai (localStorage):', localStorage.getItem('token') ? 'EXISTS' : 'NULL');
		//console.log('🔍 Token BEFORE getAllTrangthai (TokenManager):', tokenManager.isAuthenticated() ? 'EXISTS' : 'NULL');

		// Only load non-menu related data here
		await mainService.getAllTrangthai(dispatch);

		//console.log('🔍 Token AFTER getAllTrangthai (localStorage):', localStorage.getItem('token') ? 'EXISTS' : 'NULL');
		//console.log('🔍 Token AFTER getAllTrangthai (TokenManager):', tokenManager.isAuthenticated() ? 'EXISTS' : 'NULL');

		//await icdService.getAllICD(dispatch);
		//await nhacungcapService.getAllNCC(dispatch);

		// DO NOT call any menu-related APIs here
		// Menu should only be loaded by MenuSidebar component
	};

	const fetchProfile = async () => {
		try {
			//console.log('📍 Main: fetchProfile called - EXACT TIME:', new Date().toISOString());

			// Use TokenManager instead of direct localStorage access
			const tokenExists = tokenManager.isAuthenticated();
			//console.log('📍 Main: TokenManager says authenticated:', tokenExists);

			if (!tokenExists) {
				//console.log('❌ Main: No token found via TokenManager, logging out immediately');
				dispatch(logoutUser());
				updateAppLoading(false);
				return;
			}

			// Token exists via TokenManager, so continue
			//console.log('✅ Main: Token found via TokenManager, continuing without verification');
			updateAppLoading(false);

		} catch (error) {
			console.error('💥 Main: fetchProfile error:', error);
			updateAppLoading(false);
		}
	};

	// Setup periodic token verification (but not on initial load)
	const setupTokenVerification = () => {
		const verifyToken = async () => {
			try {
				//console.log('Main: Periodic token verification');
				const res = await AuthService.verify_token();

				if (!res.flag) {
					//console.log('Main: Periodic verification failed:', res.msg);
					alertService.info('Session expired. Please login again.');
					dispatch(logoutUser());
				}
			} catch (error) {
				console.error('Main: Periodic verification error:', error);
			}
		};

		// Verify token every 10 minutes, starting 1 minute after app load
		intervalRef.current = setInterval(verifyToken, 10 * 60 * 1000);

		// Also verify once after 1 minute (to give the app time to settle)
		setTimeout(verifyToken, 60 * 1000);
	};

	// Check if user should see navigation
	const shouldShowNavigation = () => {
		try {
			// Use TokenManager instead of direct localStorage access
			const userProfile = tokenManager.getProfile();
			if (userProfile) {
				const nv = JSON.parse(userProfile);
				if (nv && nv.role && nv.role.length > 0 && nv.role.includes("SALEMAN")) {
					return false;
				}
			}
			return true;
		} catch (error) {
			console.error('Main: Error checking navigation permission:', error);
			return true;
		}
	};

	// Initialize app and set up profile verification interval
	useEffect(() => {
		if (isInitializedRef.current) {
			//console.log('Main: Already initialized, skipping...');
			return;
		}

		//console.log('Main: Initializing app...');
		isInitializedRef.current = true;

		const initializeApp = async () => {
			try {
				await loadStore();
				await fetchProfile();

				// Set up periodic verification after successful initialization
				setupTokenVerification();

				//console.log('Main: App initialized successfully');
			} catch (error) {
				console.error('Main: App initialization failed:', error);
				updateAppLoading(false);
			}
		};

		initializeApp();

		return () => {
			//console.log('Main: Cleanup - clearing interval');
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, []); // Remove dispatch dependency to prevent re-initialization

	// Handle DOM class changes
	useEffect(() => {
		if (isFirstRender.current) {
			//console.log('Main: Setting up DOM classes');
			isFirstRender.current = false;

			document.getElementById('root').classList.remove('register-page');
			document.getElementById('root').classList.remove('login-page');
			document.getElementById('root').classList.remove('hold-transition');

			document.getElementById('root').classList.add('sidebar-mini');
			document.getElementById('root').classList.add('layout-fixed');
		}

		return () => {
			//console.log('Main: Cleaning up DOM classes');
			document.getElementById('root').classList.remove('sidebar-mini');
			document.getElementById('root').classList.remove('layout-fixed');
		};
	}, []);

	// Handle sidebar state changes
	useEffect(() => {
		document.getElementById('root').classList.remove('sidebar-closed');
		document.getElementById('root').classList.remove('sidebar-collapse');
		document.getElementById('root').classList.remove('sidebar-open');

		if (isSidebarMenuCollapsed && screenSize === 'lg') {
			document.getElementById('root').classList.add('sidebar-collapse');
		} else if (isSidebarMenuCollapsed && screenSize === 'xs') {
			document.getElementById('root').classList.add('sidebar-open');
		} else if (!isSidebarMenuCollapsed && screenSize !== 'lg') {
			document.getElementById('root').classList.add('sidebar-closed');
			document.getElementById('root').classList.add('sidebar-collapse');
		}
	}, [screenSize, isSidebarMenuCollapsed]);

	//console.log('Main: Rendering, appLoadingState:', appLoadingState);

	if (appLoadingState) {
		return (
			<div className="wrapper">
				<PageLoading />
			</div>
		);
	}

	return (
		<div className="wrapper">
			<Header toggleMenuSidebar={handleToggleMenuSidebar} />

			{/* Always render MenuSidebar, let it handle its own visibility */}
			{shouldShowNavigation() && <MenuSidebar />}

			<div className="content-wrapper">
				<div className="pt-3" />
				<section className="content">
					<Switch>
						<Route exact path="/capcoquan" component={CapcoquanList} />
						<Route exact path="/capcoquan/add" component={CapcoquanEdit} />
						<Route exact path="/capcoquan/view/:id" component={CapcoquanEdit} />
						<Route exact path="/capcoquan/edit/:id" component={CapcoquanEdit} />
						<Route exact path="/loaiphansucap1" component={Loaiphansucap1List} />
						<Route exact path="/loaiphansucap1/add" component={Loaiphansucap1Edit} />
						<Route exact path="/loaiphansucap1/view/:id" component={Loaiphansucap1Edit} />
						<Route exact path="/loaiphansucap1/edit/:id" component={Loaiphansucap1Edit} />
						<Route exact path="/loaiphansucap2" component={Loaiphansucap2List} />
						<Route exact path="/loaiphansucap2/add" component={Loaiphansucap2Edit} />
						<Route exact path="/loaiphansucap2/view/:id" component={Loaiphansucap2Edit} />
						<Route exact path="/loaiphansucap2/edit/:id" component={Loaiphansucap2Edit} />

						<Route exact path="/nhomphansu" component={NhomphansuList} />
						<Route exact path="/nhomphansu/add" component={NhomphansuEdit} />
						<Route exact path="/nhomphansu/view/:id" component={NhomphansuEdit} />
						<Route exact path="/nhomphansu/edit/:id" component={NhomphansuEdit} />

						<Route exact path="/nhomsukien" component={NhomsukienList} />
						<Route exact path="/nhomsukien/add" component={NhomsukienEdit} />
						<Route exact path="/nhomsukien/view/:id" component={NhomsukienEdit} />
						<Route exact path="/nhomsukien/edit/:id" component={NhomsukienEdit} />

						<Route exact path="/phanloaisukien" component={PhanloaisukienList} />
						<Route exact path="/phanloaisukien/add" component={PhanloaisukienEdit} />
						<Route exact path="/phanloaisukien/view/:id" component={PhanloaisukienEdit} />
						<Route exact path="/phanloaisukien/edit/:id" component={PhanloaisukienEdit} />

						<Route exact path="/coquan" component={CoquanList} />
						<Route exact path="/coquan/add" component={CoquanEdit} />
						<Route exact path="/coquan/view/:id" component={CoquanEdit} />
						<Route exact path="/coquan/edit/:id" component={CoquanEdit} />

						<Route exact path="/loaibieumautailieu" component={LoaibieumautailieuList} />
						<Route exact path="/loaibieumautailieu/add" component={LoaibieumautailieuEdit} />
						<Route exact path="/loaibieumautailieu/view/:id" component={LoaibieumautailieuEdit} />
						<Route exact path="/loaibieumautailieu/edit/:id" component={LoaibieumautailieuEdit} />

						<Route exact path="/bieumautailieu" component={BieumautailieuList} />
						<Route exact path="/bieumautailieu/add" component={BieumautailieuEdit} />
						<Route exact path="/bieumautailieu/view/:id" component={BieumautailieuEdit} />
						<Route exact path="/bieumautailieu/edit/:id" component={BieumautailieuEdit} />

						<Route exact path="/thanhgiao" component={ThanhgiaoList} />
						<Route exact path="/thanhgiao/add" component={ThanhgiaoEdit} />
						<Route exact path="/thanhgiao/view/:id" component={ThanhgiaoEdit} />
						<Route exact path="/thanhgiao/edit/:id" component={ThanhgiaoEdit} />

						<Route exact path="/loaithongbao" component={LoaithongbaoList} />
						<Route exact path="/loaithongbao/add" component={LoaithongbaoEdit} />
						<Route exact path="/loaithongbao/view/:id" component={LoaithongbaoEdit} />
						<Route exact path="/loaithongbao/edit/:id" component={LoaithongbaoEdit} />

						<Route exact path="/hinhthuc" component={HinhthucList} />
						<Route exact path="/hinhthuc/add" component={HinhthucEdit} />
						<Route exact path="/hinhthuc/view/:id" component={HinhthucEdit} />
						<Route exact path="/hinhthuc/edit/:id" component={HinhthucEdit} />

						<Route exact path="/phansu" component={PhansuList} />
						<Route exact path="/phansu/add" component={PhansuEdit} />
						<Route exact path="/phansu/view/:id" component={PhansuEdit} />
						<Route exact path="/phansu/edit/:id" component={PhansuEdit} />

						<Route exact path="/nhadan" component={NhadanList} />
						<Route exact path="/nhadan/add" component={NhadanEdit} />
						<Route exact path="/nhadan/view/:id" component={NhadanEdit} />
						<Route exact path="/nhadan/edit/:id" component={NhadanEdit} />

						<Route exact path="/daohuu" component={DaohuuList} />
						<Route exact path="/daohuu/add" component={DaohuuEdit} />
						<Route exact path="/daohuu/view/:id" component={DaohuuEdit} />
						<Route exact path="/daohuu/edit/:id" component={DaohuuEdit} />

						<Route exact path="/thongbao" component={ThongbaoList} />
						<Route exact path="/thongbao/add" component={ThongbaoEdit} />
						<Route exact path="/thongbao/view/:id" component={ThongbaoEdit} />
						<Route exact path="/thongbao/edit/:id" component={ThongbaoEdit} />

						<Route exact path="/sukien" component={SukienList} />
						<Route exact path="/sukiendaohuu" component={SukienDaohuuList} />
						<Route exact path="/sukiennhadan" component={SukienNhadanList} />
						<Route exact path="/sukien/add" component={SukienEdit} />
						<Route exact path="/sukien/view/:id" component={SukienEdit} />
						<Route exact path="/sukien/edit/:id" component={SukienEdit} />

						<Route exact path="/Uploads" component={Uploads} />

						<Route exact path="/sub-menu-2" component={Blank} />

						<Route exact path="/AUTHORITies" component={PhanquyenList} />
						<Route exact path="/AUTHORITies/add" component={PhanquyenEdit} />
						<Route exact path="/AUTHORITies/edit/:id" component={PhanquyenEdit} />
						<Route exact path="/AUTHORITies/view/:id" component={PhanquyenEdit} />

						<Route exact path="/phanquyenapp" component={PhanquyenappList} />
						<Route exact path="/phanquyenapp/add" component={PhanquyenappEdit} />
						<Route exact path="/phanquyenapp/edit/:id" component={PhanquyenappEdit} />
						<Route exact path="/phanquyenapp/view/:id" component={PhanquyenappEdit} />

						<Route exact path="/MEMBERs" component={UserList} />
						<Route exact path="/MEMBERs/add" component={UserEdit} />
						<Route exact path="/MEMBERs/edit/:id" component={UserEdit} />
						<Route exact path="/MEMBERs/view/:id" component={UserEdit} />

						<Route exact path="/profile" component={Profile} />
						<Route exact path="/" component={Dashboard} />
					</Switch>
				</section>
			</div>
			<Footer />
			<div id="sidebar-overlay" role="presentation" onClick={handleToggleMenuSidebar} onKeyDown={() => {}} />
		</div>
	);
};

export default Main;